<template>
<div class="page behaviour">
  <h1>Rijgedrag</h1>
</div>
</template>

<script>
export default {
name: "Behaviour"
}
</script>
